import { Checkbox } from '@material-ui/core';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import BeatLoader from 'react-spinners/BeatLoader';
import styled from 'styled-components';
import {
  manageTag,
  updateDictation
} from '../../../redux/actions/flag-actions';
import { RESERVED_TAGS } from '../../../constants/constants';
import { firebase } from '../../../firebase';
import { ReactComponent as DeleteButtonSvg } from '../../../images/delete-btn-light.svg';
import { ReactComponent as PlayButtonSvg } from '../../../images/play-btn.svg';
import { ReactComponent as ShareButtonSvg } from '../../../images/share-btn.svg';
import {
  isRetrievalTag,
  validateTagInput
} from '../../../utils/tagValidatorUtils';
import { displayNotification } from '../../../utils/utils';
import { Input } from '../../../components/ui/input/Input';
import Overlay from '../../../components/ui/tooltip/Overlay';
import CommentLabel from './CommentLabel';
import RetrievalFeedback from './RetrievalFeedback';
import TagLabel from './TagLabel';
import { isUnmatchedFlag } from '../../../utils/isUnmatchedFlag';
import { secondsToHmsCheck } from '../../../utils/secondsToHmsCheck';
import FlagKeyIdeas from '../../pdfviewer/components/flag-key-ideas/FlagKeyIdeas';
import ShowMoreText from '../../documents/components/ShowMoreText';

const EDIT_MODE = {
  TAG: 'tag',
  DICTATION: 'dictation'
};

const TagCommentInput = styled(Input)`
  ${(props) => !props.$isEditingTag && '  flex: 1; max-width: 600px;'};
  background-color: var(--color-light-gray);
  color: var(--color-black);
`;

class FlagRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isInputVisible: false,
      value: '',
      editMode: EDIT_MODE.TAG
    };
  }

  getTagValue = (flag) =>
    (flag?.tag === RESERVED_TAGS.FLASH && flag?.flashflag) ||
    flag?.tag === RESERVED_TAGS.UNTAGGED
      ? ''
      : flag?.tag;

  handleBtnClick = (flag, mode) => {
    if (flag.sharedNoteInfo !== null) return;

    this.setState({
      isInputVisible: true,
      editMode: mode,
      value: mode === EDIT_MODE.TAG ? this.getTagValue(flag) : flag?.dictation
    });
  };

  handleInputBlur = () => {
    this.setState({
      isInputVisible: false,
      value: ''
    });
  };

  closeInput = () => this.setState({ isInputVisible: false });

  handleChange = (e) => this.setState({ value: e.target.value });

  updateTagOrDictation = async (payload, mode, errorMessage) => {
    try {
      const token = await firebase.auth.currentUser.getIdToken();
      if (mode === EDIT_MODE.TAG) {
        await this.props.dispatch(manageTag(token, payload));
      } else {
        await this.props.dispatch(updateDictation(token, payload));
      }

      this.closeInput();
    } catch (error) {
      this.props.handleTagCommentError(true, errorMessage);
      console.error(error);
    }
  };

  validateTag = (inputValue, flag) => {
    const { MY_AUDIO_FEEDBACK } = RESERVED_TAGS;
    const [isValid, errorMessage] = validateTagInput(inputValue);

    if (!isValid && errorMessage) {
      displayNotification(errorMessage, {
        allowEnterKey: false,
        showCloseButton: true
      });
      return false;
    }

    if (flag.tag === MY_AUDIO_FEEDBACK) {
      displayNotification('Cannot change this tag.', {
        allowEnterKey: false,
        showCloseButton: true
      });
      return false;
    }

    return true;
  };

  saveTagComment = (value, flag, mode) => {
    const inputValue = value?.trim();
    let request = {};

    if (mode === EDIT_MODE.TAG) {
      if (!this.validateTag(inputValue, flag)) {
        return;
      }

      request.flagId = flag.flagId;
      if (inputValue === '') {
        request.tag = RESERVED_TAGS.FLASH;
        request.flashflag = true;
      } else {
        request.tag = inputValue;
        request.flashflag = false;
      }
      this.updateTagOrDictation(request, mode, 'Error editing tag');
    }

    if (mode === EDIT_MODE.DICTATION) {
      request.id = flag.flagId;
      request.dictation = inputValue;
      this.updateTagOrDictation(request, mode, 'Error editing dictation');
    }
  };

  pressEnter = (e, flag, mode) => {
    e.stopPropagation();

    const inputValue = e.target.value;

    if (e.key === 'Enter') {
      this.saveTagComment(inputValue, flag, mode);
    }
  };

  handleSharedByNames = (users) => {
    const names = users.map((user) => user.name);
    const sharedByNames = names.join(', ');
    return sharedByNames;
  };

  renderEditables = (flag) => {
    const { DOWNTAG, UPTAG, UNTAGGED } = RESERVED_TAGS;

    if (
      flag.sharedNoteInfo &&
      (!flag.sharedNoteInfo.sharedCommentEnabled ||
        (flag.sharedNoteInfo.sharedCommentEnabled && flag.dictation === '')) &&
      flag?.tag !== DOWNTAG &&
      flag?.tag !== UPTAG
    ) {
      return <></>;
    }

    if (
      flag.sharedNoteInfo &&
      flag.sharedNoteInfo.sharedCommentEnabled &&
      flag.dictation !== '' &&
      flag?.tag !== DOWNTAG &&
      flag?.tag !== UPTAG
    ) {
      return (
        <span style={{ marginLeft: '2px' }}>
          <CommentLabel dictation={flag.dictation} />
        </span>
      );
    }

    return (
      <span style={{ marginLeft: '2px' }}>
        <CommentLabel
          dictation={flag?.dictation}
          {...(!isRetrievalTag(flag?.tag) && {
            onCommentClick: () => this.handleBtnClick(flag, EDIT_MODE.DICTATION)
          })}
        />
        <span
          style={{ marginRight: '4px', fontWeight: 'bold', color: 'inherit' }}
        >
          {!flag?.dictation &&
          (flag.tag === '' || flag?.tag?.trim() === UNTAGGED)
            ? '|'
            : ''}
        </span>
        <TagLabel
          tag={flag?.tag}
          flashflag={flag?.flashflag}
          onTagClick={() => this.handleBtnClick(flag, EDIT_MODE.TAG)}
        />
      </span>
    );
  };

  render() {
    const {
      flag,
      handleDocumentPlay,
      selectedItems,
      handleItemSelect,
      playerDocument,
      refresh,
      hiddenSelectionCheckbox
    } = this.props;

    const { value, isInputVisible, editMode } = this.state;

    const isShared =
      flag.sharedNoteInfo && Array.isArray(flag.sharedNoteInfo.sharers) && flag.sharedNoteInfo.sharers.length > 0
        ? true
        : false;

    const isEditingTag = editMode === EDIT_MODE.TAG;

    const isFlagLocked = isRetrievalTag(flag?.tag);

    return (
      <Row className="flags-list-item__item-row" key={flag.flagId}>
        <Col xs={9}>
          <article className="flags-list-item__single-flag">
            <div style={{ flex: 1, wordBreak: 'break-word' }}>
              {flag.isProcessing && flag.text === null && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    alignSelf: 'stretch',
                    gap: '8px'
                  }}
                >
                  <div>Transcription in progress</div>

                  <div style={{ cursor: 'pointer' }} onClick={refresh}>
                    <i
                      className="fa fa-refresh"
                      aria-hidden="true"
                      style={{
                        fontSize: '13pt',
                        color: 'var(--color-ai-green)'
                      }}
                      title="Refresh"
                    />
                  </div>
                </div>
              )}
              {isRetrievalTag(flag.tag) ? (
                <div
                  style={{
                    fontSize: '16px',
                    fontWeight: '400',
                    marginBottom: '40px'
                  }}
                >
                  {flag.text ? flag.text : ''}
                  <span style={{ marginLeft: '2px' }}>
                    {`(${secondsToHmsCheck(flag?.trackPosition)})`}
                  </span>
                  {flag.dictation && (
                    <RetrievalFeedback
                      tag={flag.tag}
                      dictation={flag.dictation}
                    />
                  )}
                </div>
              ) : (
                <div>
                  <ShowMoreText lines={2} fontSize="small" useIcon={false}>
                    {flag?.text}
                  </ShowMoreText>
                  <FlagKeyIdeas keyIdeas={flag?.keyIdeas} />
                  <span style={{ marginLeft: '2px' }}>
                    {`(${secondsToHmsCheck(flag?.trackPosition)})`}
                  </span>
                  {this.renderEditables(flag)}
                </div>
              )}
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                {isInputVisible && (
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <TagCommentInput
                      value={value || ''}
                      type="text"
                      hidden={!isInputVisible}
                      onBlur={this.handleInputBlur}
                      onChange={this.handleChange}
                      onKeyDown={(event) =>
                        this.pressEnter(event, flag, editMode)
                      }
                      autoFocus
                      placeholder={isEditingTag ? 'Add Tag' : 'Add Comment'}
                      $isEditingTag={isEditingTag}
                    />
                    <div style={{ textAlign: 'end', marginLeft: '4px' }}>
                      <Overlay
                        text={isEditingTag ? 'Save Tag' : 'Save Comment'}
                      >
                        <i
                          onMouseDown={() =>
                            this.saveTagComment(value, flag, editMode)
                          }
                          className="fa fa-check-square tag-check"
                          aria-hidden="true"
                        ></i>
                      </Overlay>
                      <Overlay text="Cancel">
                        <i
                          onMouseDown={this.closeInput}
                          className="fa fa-window-close tag-close"
                          aria-hidden="true"
                        ></i>
                      </Overlay>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </article>
        </Col>
        <Col xs={3}>
          <div className="flags-list-item__single-flag-actions">
            {flag?.podcastTypeIds?.length > 0 &&
            flag?.podcastTypeIds[0] === 5 &&
            !isFlagLocked &&
            !isUnmatchedFlag(flag?.trackPosition) &&
            !flag?.isOwner ? (
              !isShared ? (
                <span onClick={() => this.props.openShareModal(flag)}>
                  <ShareButtonSvg fill="#7d7d7f" />
                </span>
              ) : (
                <span style={{ cursor: 'not-allowed' }}>
                  <ShareButtonSvg fill="#7d7d7f" />
                </span>
              )
            ) : null}
            {!hiddenSelectionCheckbox && (
              <Checkbox
                hidden={hiddenSelectionCheckbox}
                className="share-flags-modal__checkbox"
                checked={selectedItems.includes(flag)}
                onChange={() => handleItemSelect(flag)}
                icon={<RadioButtonUncheckedIcon fontSize="large" />}
                checkedIcon={<RadioButtonCheckedIcon fontSize="large" />}
              />
            )}
            {hiddenSelectionCheckbox && !isUnmatchedFlag(flag?.trackPosition) && (
              <span onClick={() => handleDocumentPlay(flag)}>
                <PlayButtonSvg
                  fill={
                    playerDocument.flagId === flag.flagId ? '#7acd7a' : '#7d7d7f'
                  }
                />
              </span>
            )}
            {hiddenSelectionCheckbox && !isFlagLocked && (
              <span
                className="delete-icon"
                onClick={() => this.props.handleDeleteFlag([flag])}
              >
                <DeleteButtonSvg stroke="#7d7d7f" fill="none" />
              </span>
            )}
          </div>
          {flag.sharedNoteInfo && Array.isArray(flag.sharedNoteInfo.sharers) && (
            <div className="single-flags__shared-info">
              <span className="shared-by">
                {this.handleSharedByNames(flag.sharedNoteInfo.sharers)}
              </span>
            </div>
          )}
        </Col>
      </Row>
    );
  }
}

export default connect()(FlagRow);
